import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as model from "../../../../models";

@Component({
	selector: 'booking-offices',
	templateUrl: "./booking-offices.component.html",
	styles:[require("./booking-offices.component.scss")]
	// changeDetection: ChangeDetectionStrategy.OnPush,			please refer: issue #33
})
export class BookingOfficesComponent {
	private selected = {};

	@Input()
	bookingOffices: model.BookingOffice[];

	@Input()
	set ticketQuota(ticketQuota: model.TicketQuota) {
		if (!ticketQuota) return;
		this.deselectAll();
		for (const uuid of ticketQuota.allowedBookingOfficeUUIDs){
			this.selected[uuid] = true;
		}
	}

	@Output()
	saveClicked = new EventEmitter<string[]>();

	selectAll() {
		for (let bo of this.bookingOffices) {
			this.selected[bo.uuid] = true;
		}
	}

	deselectAll() {
		if (! this.bookingOffices) return;
		for (let bo of this.bookingOffices) {
			this.selected[bo.uuid] = false;
		}
	}

	save() {
		const list: string[] = this.bookingOffices
					.filter(bo => this.selected[bo.uuid])
					.map(bo => bo.uuid);
		this.saveClicked.emit(list);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-quota-collection/booking-offices/booking-offices.component.ts